module.exports = __webpack_public_path__ + "static/media/mongo.b093ef42.png";